<template>
  <v-card v-bind="$attrs">
    <v-card-title class="title">
      Data Validation Modes
    </v-card-title>
    <v-list dense>
      <v-list-tile v-for="(row, i) in descriptions" :key="`info-row-${i}`">
        <v-list-tile-content><span class="font-weight-bold success--text">{{row.name}}</span> {{row.description}}
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat small>Close</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import {
    columnDataValidationModeDescriptions,
  } from '../../store/columnDataValidationModes'

  export default {
    computed: {
      descriptions() {
        return Object.values(columnDataValidationModeDescriptions)
      },
    },
  }

</script>
